import React, { useMemo } from 'react';
import { motion } from 'framer-motion';

const SparkleEffect = ({ count = 8, className = '', color = '#ec4899', size = 'mixed' }) => {
  const sparkles = useMemo(() => {
    return [...Array(count)].map((_, i) => ({
      id: i,
      x: `${Math.random() * 100}%`,
      y: `${Math.random() * 100}%`,
      delay: Math.random() * 3,
      duration: 2 + Math.random() * 2,
      sparkleSize: size === 'mixed' 
        ? [6, 8, 10, 12, 14][Math.floor(Math.random() * 5)]
        : size === 'small' ? 6 : size === 'large' ? 14 : 10,
    }));
  }, [count, size]);

  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}>
      {sparkles.map((s) => (
        <motion.div
          key={s.id}
          className="absolute"
          style={{ left: s.x, top: s.y }}
          initial={{ scale: 0, opacity: 0 }}
          animate={{
            scale: [0, 1, 0.5, 1, 0],
            opacity: [0, 1, 0.6, 1, 0],
            rotate: [0, 90, 180, 270, 360],
          }}
          transition={{
            duration: s.duration,
            delay: s.delay,
            repeat: Infinity,
            repeatDelay: Math.random() * 2,
            ease: 'easeInOut',
          }}
        >
          <svg
            width={s.sparkleSize}
            height={s.sparkleSize}
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12 0L14.59 8.41L23 12L14.59 15.59L12 24L9.41 15.59L1 12L9.41 8.41L12 0Z"
              fill={color}
              fillOpacity="0.7"
            />
          </svg>
        </motion.div>
      ))}
    </div>
  );
};

export default SparkleEffect;
